import Layout from '../components/Layout';
import Vacancies from '@/components/Vacancies';
import API from '../api';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import {getServerSidePaths} from "@/pages/contacts/[slug]";

// Заглушка для переводов
const translate = s => s;

const VacanciesPage = ({ data }) => <Vacancies data={data} />;

const breadcrumbs = [
  { title: translate('Главная'), route: '/' },
  { title: translate('Вакансии'), route: '/vacancies' },
];

VacanciesPage.getLayout = (page, t) => (
  <Layout page={page.props} breadcrumbs={breadcrumbs} title={t('Вакансии — UNIFROST')}>
    {page}
  </Layout>
);

export async function getServerSideProps(context) {
  const props = { data: { vacancies: [] } };

  try {
    const res = await API.get(`/v1/api/pages/vacancies/`, {
      headers: { 'Accept-Language': context.locale },
    });

    if (res.status === 200) {
      if (res.data) props.data = res.data;
    }
  } catch (error) {}

  try {
    const resVacancies = await API.get(`/v1/api/vacancies/`, {
      headers: { 'Accept-Language': context.locale },
    });

    if (resVacancies.status === 200 && Array.isArray(resVacancies.data)) {
      if (resVacancies.data) props.data.vacancies = resVacancies.data;
    }
  } catch (error) {}

  return {
    props: {
      ...props,
      ...(await serverSideTranslations(context.locale, ['common', 'menu', 'vacancy'])),
    },
    // revalidate: 60,
  };
}

export default VacanciesPage;
